import { render, staticRenderFns } from "./BannersTab.vue?vue&type=template&id=b9d0071a&scoped=true"
import script from "./BannersTab.vue?vue&type=script&lang=js"
export * from "./BannersTab.vue?vue&type=script&lang=js"
import style0 from "./BannersTab.vue?vue&type=style&index=0&id=b9d0071a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d0071a",
  null
  
)

export default component.exports